import { PluginFields } from "types/enums";
import { AdminSettings, Settings } from "view/admin/utils/admin.types";

export const convertSettingsToData = (applicationSettings: Settings | AdminSettings) => {

	const plugins = Object.fromEntries((applicationSettings.plugins ?? []).map((plugin) => {
		const isEnabled = "enabled" in plugin ? plugin.enabled : false;
		return [ plugin.key, isEnabled ];
	})) as Record<string, boolean>;

	const settings = Object.fromEntries(("settings" in applicationSettings ? applicationSettings.settings ?? [] : [])
		.map(setting => [ setting.key, setting.setting ])) as Record<string, string>;

	const fields = Object.fromEntries((applicationSettings.fields ?? []).map((field) => {
		const targetKey = "key" in field ? field.key : field.name;
		const targetFields = "fields" in field ? field.fields ?? [] : [];

		return [ targetKey, targetFields ];
	})) as Record<PluginFields, string[]>;

	const multiValues = Object.fromEntries(
		("multiValues" in applicationSettings ? applicationSettings.multiValues ?? [] : []).map(
			(multiValue) => [ multiValue.key, multiValue.multiValue ],
		),
	) as Record<string, string>;

	return {
		timestamp: applicationSettings.timestamp,
		applicationVersion: applicationSettings.applicationVersion,
		plugins: plugins,
		settings: settings,
		fields: fields,
		multiValues: multiValues,
	};
};
